import api from '../utils/api.js';

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useFlashMessage from './useFlashMessage.js';


function useAuth() {
    const [authenticated, setAuthenticated] = useState(false);
    const { flashMessage } = useFlashMessage();
    const navigate = useNavigate();
    
    useEffect(() => {
        const token = localStorage.getItem('access');
        if (token) {
            api.defaults.headers.Authorization = token;
            setAuthenticated(true);
        }
        if(window.location.pathname==="/admin/cms"&&(api.defaults.headers.Authorization===undefined||api.defaults.headers.Authorization!==localStorage.getItem('access'))){
            flashMessage("acesso não autorizado","error");
            navigate('/');
            navigate(0);
        }
    }, [flashMessage,navigate]);

        


    async function login(username, password) {

        let msgText = "Login realizado com sucesso!";
        let msgType = "success";

        try {
            const response = await api.post('/admin/login', { username, password });
            const { data } = response;
            setAuthenticated(true);
            localStorage.setItem('access', data?.Token);
            flashMessage(msgText, msgType);
            navigate('/admin/cms');
            navigate(0);

            return data;
        } catch (error) {
            msgText = error.response?.data?.message || 'Não foi possível realizar o login. Verifique se o nome de usuário e a senha estão corretos e tente novamente.';
            msgType = "error";
        }

        flashMessage(msgText, msgType);

    }

    function logout() {
        const msgText = "Logout realizado com sucesso!";
        const msgType = "success";

        setAuthenticated(false);
        localStorage.removeItem('access');
        api.defaults.headers.Authorization = undefined;
        flashMessage(msgText, msgType);
        navigate('/');
        navigate(0);
    }

    return { login, logout, authenticated };
}

export default useAuth;